import React, { Suspense } from "react";
import { HashRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import Router from './router';
import { ZeusLoader } from "./components/ZeusLoader";
import "./styles.scss"

function App() {
  return (
    <Suspense fallback={<ZeusLoader />}>
      <HashRouter>
        <Router />
        <Toaster 
          position="top-right" 
          duration={4000} 
          toastOptions={{
            className: 'toaster-custom',
            closeButton: true,
          }} 
        />
      </HashRouter>
    </Suspense>
  );
}

export default App
